export default __webpack_public_path__ + "static/media/msg-notice.266ab4d7.svg";